// @flow
import * as React from "react";

import { PhoneNumberInput } from "../atoms/PhoneNumberInput";
import BaseField, { type Props as FieldProps } from "./BaseField";

type Props = FieldProps & PhoneInputProps;

// TODO: Understand why we have PhoneFiled and PhoneFieldAlt
const PhoneFieldAlt: React.ComponentType<Props> = React.forwardRef(
  (props: Props, ref) => {
    const { hasError, ...rest } = props;

    return (
      <BaseField {...rest} semibold hasError={hasError}>
        <PhoneNumberInput {...rest} hasError={hasError} />
      </BaseField>
    );
  },
);

export default PhoneFieldAlt;
